<script lang="ts">
    import {onMount} from "svelte";
    import PortalView from "../../../../component/common/Portal/PortalView.svelte";
    import DialogView from "../../../../component/common/Dialog/DialogView.svelte";
    import {UrlUtil} from "../../../../lib/Common/Http/UrlUtil";
    import {HttpRequestUtil} from "../../../../lib/Common/Http/HttpRequestUtil";
    import LoadingContentView from "../../../../component/common/Loading/LoadingContentView.svelte";
    import ArraySlotView from "../../../../component/common/Value/ArraySlotView.svelte";
    import AppAccessTokenRowView from "./AppAccessTokenRowView.svelte";
    import AppAccessTokenEditDialogView from "./AppAccessTokenEditDialogView.svelte";
    import AddButtonView from "../../../../component/common/Button/AddButtonView.svelte";

    export let isShow = false;
    export let app;

    let appAccessTokens = null;

    let isLoading = false;
    let editData = null;

    onMount(() => {
    });

    function onShow() {
        loadData();

    }

    function loadData() {
        const paramMap = {};
        paramMap['app_id'] = app.id;
        paramMap['visible_access_token'] = undefined;

        const url = UrlUtil.createApiUrl("app_access_token", paramMap);

        isLoading = true;
        HttpRequestUtil.getRequest(url, (response) => {
            isLoading = false;
            console.log(response);
            const body = response['body'];
            appAccessTokens = body['app_access_tokens'];


        });
    }

    function onEdit(event) {
        const appAccessToken = event.detail.appAccessToken;
        console.log({appAccessToken});
        editData = {...appAccessToken};
    }

    function onClickAdd() {
        editData = {
            app_id: app.id
        };
    }


</script>

<PortalView>
    <DialogView title="アプリアクセストークン設定" isShow={isShow} on:show={onShow} on:close>
        <div class="app-access-token-dialog-content">
            <LoadingContentView isLoading={isLoading}>
                <ArraySlotView array={appAccessTokens}>
                    <table>
                        <thead>
                        <tr>
                            <th></th>
                            <th>名前</th>
                            <th class="type">タイプ</th>
                            <th>アクセストークン</th>
                            <th class="expire-at">有効期限</th>
                            <th>使用回数</th>
                            <th>前回使用時</th>
                            <th>作成更新情報</th>
                        </tr>

                        </thead>
                        <tbody>
                        {#each appAccessTokens as appAccessToken}
                            <AppAccessTokenRowView appAccessToken={appAccessToken} on:edit={onEdit}/>
                        {/each}
                        </tbody>
                    </table>


                </ArraySlotView>

                <div class="button-area">
                    <AddButtonView on:click={onClickAdd}/>
                </div>


            </LoadingContentView>


        </div>

    </DialogView>
</PortalView>

<AppAccessTokenEditDialogView
        app={app}
        editData={editData}
        on:update={loadData}
        on:close={()=>{
            editData = null;
        }}

/>

<style lang="scss">
    .app-access-token-dialog-content {
        min-height: 300px;

        table {
            thead {
                th {
                    &.type {
                        min-width: 100px;
                    }

                    &.expire-at {
                        min-width: 150px;
                    }
                }
            }
        }

        .button-area {
            margin-top: 60px;
        }

    }
</style>